module.exports = __webpack_public_path__ + "static/media/mafia1.fe8e2970.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mafia1.png
// module id = 294
// module chunks = 0